// Bullet inputs are bound to fixed array slots (`bullets.0`, `bullets.1`, ...), so
// unfilled or cleared slots reach the payload as null. The API only accepts arrays
// of strings, so drop the blanks and close the gaps.
const normalizeBullets = (bullets) => {
  if (!Array.isArray(bullets)) {
    return [];
  }
  return bullets.filter((bullet) => typeof bullet === 'string' && bullet.trim());
};

export default normalizeBullets;
